export const SCENARIO_ACTIONS = {
    CREATE_SCENARIO: "CREATE_SCENARIO",
    EDIT_SCENARIO: "EDIT_SCENARIO",
    DELETE_SCENARIO: "DELETE_SCENARIO",
    DETACH_SCENARIO_COLLECTION: "DETACH_SCENARIO_COLLECTION",
};
